import * as React from 'react'

export type Scope = Window | React.RefObject<HTMLElement>

export interface Config {
  dependencies?: any[]
  event: string
  handler: React.EventHandler<any>
  options?: AddEventListenerOptions
  scope?: Scope
}

export const useEventListener = ({
  dependencies = [],
  event,
  handler,
  options = {},
  scope = window,
}: Config) => {
  if (!event) {
    console.warn(`"event" option missing, no listeners added`)
  } else if (!handler) {
    console.warn(`"handler" option missing, no listeners added`)
  }
  const actualScope =
    scope === window
      ? { current: window }
      : (scope as React.RefObject<HTMLElement>)

  const listener = useEventCallback({ handler, dependencies })

  React.useEffect(() => {
    const { current } = actualScope
    if (current) {
      current.addEventListener(event, listener, options)
      return () => current.removeEventListener(event, listener, options)
    }
  }, [event, listener, actualScope.current])
}

export interface EventCallbackConfig {
  handler: React.EventHandler<any>
  dependencies?: Array<any>
}
export const useEventCallback: (
  config: EventCallbackConfig
) => React.EventHandler<any> = ({ handler, dependencies = [] }) => {
  const ref = React.useRef(handler)

  React.useLayoutEffect(() => {
    ref.current = handler
  }, [handler, ...dependencies])

  return React.useCallback(event => ref.current(event), [])
}
